import React from "react";

function SvgIcMapPoi116(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.582 15.276c.957.838 1.421 1.633 1.418 2.428-.004 1.038-.787 1.715-1.358 2.208-.218.188-.622.537-.642.672 0 .001.023.228.582.718.411.36.444.976.074 1.375a1.006 1.006 0 01-.743.323 1.01 1.01 0 01-.669-.25c-.84-.736-1.247-1.447-1.244-2.174.004-.989.73-1.617 1.315-2.12.272-.237.684-.592.685-.759 0-.032-.02-.329-.756-.974-.84-.736-1.247-1.447-1.244-2.174.004-.988.73-1.616 1.315-2.12.272-.236.684-.59.685-.759 0-.03-.02-.328-.756-.973a.957.957 0 01-.074-1.375 1.018 1.018 0 011.412-.072c.957.838 1.421 1.632 1.418 2.428-.004 1.038-.787 1.714-1.358 2.208-.218.187-.622.536-.642.671 0 0 .023.23.582.72zM26 13.166l-2.523-4.33-4.954 2.834V6h-5.046v5.67L8.523 8.835 6 13.165 10.955 16 6 18.835l2.523 4.33 4.954-2.835V26h5.046v-5.67l4.954 2.835L26 18.835 21.045 16 26 13.165z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi116;
